import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/lib/utils'

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer size-4.5 shrink-0 rounded border border-white/30 bg-white/10 transition-all outline-none',
        'data-[state=checked]:bg-[#007AFF] data-[state=checked]:border-[#007AFF]',
        'focus-visible:ring-2 focus-visible:ring-[#007AFF]/50',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'rounded-xs! p-2! pt-0.5!',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="grid place-content-center text-white">
        <CheckIcon className="size-3.5 stroke-[2.5]" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
